import React from "react";
import { useState } from "react";
import { Modal, notification } from "antd";
import { Field, reduxForm } from "redux-form";
import validator from "validator";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress } from "@mui/material";

import { customInput } from "../../common/custom-input";
import v2Styles from "../v2Styles.module.css";
import jobStyles from "../Job/JobStyle.module.css";
import "../../../AppV3.css";
import { Strings } from "../../../dataProvider/localize";

const validate = (values) => {
  const errors = {};
  const isDigitsOnly = (value) => /^\d+$/.test(value);

  if (
    values.admin_email_address &&
    values.admin_email_address.trim() !== "" &&
    !validator.isEmail(values.admin_email_address.trim())
  ) {
    errors.admin_email_address = "Invalid email";
  }
  if (
    values.client_person_email &&
    values.client_person_email.trim() !== "" &&
    !validator.isEmail(values.client_person_email.trim())
  ) {
    errors.client_person_email = "Invalid email";
  }
  if (
    values.admin_phone_number &&
    values.admin_phone_number.trim() !== "" &&
    !isDigitsOnly(values.admin_phone_number.trim())
  ) {
    errors.admin_phone_number = "Phone number must contain numbers only";
  }
  if (
    values.client_person_phone &&
    values.client_person_phone.trim() !== "" &&
    !isDigitsOnly(values.client_person_phone.trim())
  ) {
    errors.client_person_phone = "Phone number must contain numbers only";
  }
  return errors;
};

const EditInfoDetailsForm = (props) => {
  const { handleSubmit, onClose, saving } = props;

  return (
    <div className="v2-modal-container">
      <form onSubmit={handleSubmit}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className={v2Styles.ModalHeading}>Report Info</div>
              <div>
                <hr className="v3-modal-hr" />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-md-6 pb-3 border-right">
              <div className={`${jobStyles.SectionHeading} mb-2`}>By</div>

              <div className="pb-2">
                <div className={v2Styles.Label}>Documents Prepared By</div>
                <Field
                  name="admin_name"
                  type="text"
                  disabled={saving}
                  autoComplete="off"
                  className={v2Styles.TextField}
                  component={customInput}
                />
              </div>

              <div className="pb-2">
                <div className={v2Styles.Label}>Company</div>
                <Field
                  name="org_name"
                  type="text"
                  disabled={saving}
                  autoComplete="off"
                  className={v2Styles.TextField}
                  component={customInput}
                />
              </div>

              <div className="pb-2">
                <div className={v2Styles.Label}>Address</div>
                <Field
                  name="address"
                  type="text"
                  disabled={saving}
                  autoComplete="off"
                  className={v2Styles.TextField}
                  component={customInput}
                />
              </div>

              <div className="pb-2">
                <div className={v2Styles.Label}>Mobile</div>
                <Field
                  name="admin_phone_number"
                  type="text"
                  disabled={saving}
                  autoComplete="off"
                  className={v2Styles.TextField}
                  component={customInput}
                />
              </div>

              <div className="pb-2">
                <div className={v2Styles.Label}>Email</div>
                <Field
                  name="admin_email_address"
                  type="text"
                  disabled={saving}
                  autoComplete="off"
                  className={v2Styles.TextField}
                  component={customInput}
                />
              </div>
            </div>

            <div className="col-12 col-md-6 pb-3">
              <div className={`${jobStyles.SectionHeading} mb-2`}>To</div>

              <div className="pb-2">
                <div className={v2Styles.Label}>Attention</div>
                <Field
                  name="client_person_name"
                  type="text"
                  disabled={saving}
                  autoComplete="off"
                  className={v2Styles.TextField}
                  component={customInput}
                />
              </div>

              <div className="pb-2">
                <div className={v2Styles.Label}>Company</div>
                <Field
                  name="client_name"
                  type="text"
                  disabled={saving}
                  autoComplete="off"
                  className={v2Styles.TextField}
                  component={customInput}
                />
              </div>

              <div className="pb-2">
                <div className={v2Styles.Label}>Address</div>
                <Field
                  name="client_address"
                  type="text"
                  disabled={saving}
                  autoComplete="off"
                  className={v2Styles.TextField}
                  component={customInput}
                />
              </div>

              <div className="pb-2">
                <div className={v2Styles.Label}>Mobile</div>
                <Field
                  name="client_person_phone"
                  type="text"
                  disabled={saving}
                  autoComplete="off"
                  className={v2Styles.TextField}
                  component={customInput}
                />
              </div>

              <div className="pb-2">
                <div className={v2Styles.Label}>Email</div>
                <Field
                  name="client_person_email"
                  type="text"
                  disabled={saving}
                  autoComplete="off"
                  className={v2Styles.TextField}
                  component={customInput}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="d-flex align-items-center justify-content-end" style={{ gap: "5px" }}>
                {saving ? <CircularProgress size={20} /> : ""}
                <button type="button" disabled={saving} className={v2Styles.OutlinedButton} onClick={onClose}>
                  Cancel
                </button>
                <button disabled={saving} className={v2Styles.PrimaryButton} type="submit">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

const ReduxEditInfoDetailsForm = reduxForm({
  form: "cleaningReportEditInfoDetails",
  validate,
  enableReinitialize: true,
})(EditInfoDetailsForm);

const EditInfoDetailsModal = ({ visible, onClose, initialValues, onSave, onSaveApi, jobId }) => {
  const [saving, setSaving] = useState(false);

  const getPayload = (values) => ({
    job_report_info: {
      by: {
        admin_name: values.admin_name ? values.admin_name : "",
        org_name: values.org_name ? values.org_name : "",
        address: values.address ? values.address : "",
        admin_phone_number: values.admin_phone_number ? values.admin_phone_number : "",
        admin_email_address: values.admin_email_address ? values.admin_email_address : "",
      },
      to: {
        client_person_name: values.client_person_name ? values.client_person_name : "",
        client_name: values.client_name ? values.client_name : "",
        client_address: values.client_address ? values.client_address : "",
        client_person_phone: values.client_person_phone ? values.client_person_phone : "",
        client_person_email: values.client_person_email ? values.client_person_email : "",
      },
    },
  });

  const handleSubmit = async (values) => {
    if (!onSaveApi || !jobId) {
      notification.error({
        message: Strings.error_title,
        description: Strings.generic_error,
        className: "ant-error",
      });
      return;
    }

    setSaving(true);

    try {
      const response = await onSaveApi(jobId, getPayload(values));

      notification.success({
        message: Strings.success_title,
        description: response && response.message ? response.message : Strings.success_title,
        className: "ant-success",
      });

      if (onSave) {
        await onSave();
      }

      onClose();
    } catch (message) {
      const errorMessage = Array.isArray(message)
        ? message[0] && message[0].message ? message[0].message : Strings.generic_error
        : message;

      notification.error({
        message: Strings.error_title,
        description: errorMessage ? errorMessage : Strings.generic_error,
        className: "ant-error",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      className="cs-modal-v2"
      visible={visible}
      centered
      width="800px"
      footer={null}
      bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
      maskClosable={false}
      destroyOnClose={true}
      onCancel={onClose}
      closeIcon={<div className={v2Styles.ModalCloseIcon}><CloseIcon /></div>}
    >
      <ReduxEditInfoDetailsForm
        initialValues={initialValues}
        onClose={onClose}
        onSubmit={handleSubmit}
        saving={saving}
      />
    </Modal>
  );
};

export default EditInfoDetailsModal;